import React from "react";
import { ThemeProvider } from "@mui/material";
import PropTypes from "prop-types";

/**
 * CThemeProvider - A wrapper for MUI ThemeProvider with additional functionality
 * 
 * @param {Object} props
 * @param {React.ReactNode} props.children - The content to be themed
 * @param {Object} props.theme - Theme object for styling (required)
 * @returns {JSX.Element}
 */
const CThemeProvider = ({
  children,
  theme,
  ...rest
}) => {
  if (!theme) {
    console.warn('CThemeProvider: No theme provided. Make sure to pass a theme object.');
  }

  return (
    <ThemeProvider
      theme={theme}
      {...rest}
    >
      {children}
    </ThemeProvider>
  );
};

CThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
  theme: PropTypes.object.isRequired,
};

export default CThemeProvider;